<template>
  <div class="rat-mascot-reply-body" :class="{ 'rat-mascot-reply-body--page': pageMode }">
    <template v-if="parsed.hasSegments">
      <template v-for="(seg, si) in parsed.segments" :key="`seg-${si}`">
        <div v-if="seg.type === 'table'" class="rat-mascot-reply-table-wrap">
          <table class="rat-mascot-reply-table">
            <thead>
              <tr>
                <th
                  v-for="(header, hi) in seg.headers"
                  :key="`th-${si}-${hi}`"
                  :class="tableHeaderClass(header)"
                >
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, ri) in tableBodyRows(seg)" :key="`tr-${si}-${ri}`">
                <td
                  v-for="(cell, ci) in row"
                  :key="`td-${si}-${ri}-${ci}`"
                  :class="tableCellClass(seg.headers[ci], cell)"
                >
                  {{ formatTableCell(cell) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <AssistantReplyTextSegment
          v-else-if="seg.type === 'text'"
          :segment="seg"
          :segment-key="`seg-${si}`"
        />
      </template>
    </template>
    <AssistantReplyTextSegment
      v-else-if="parsed.hasStructuredItems"
      :segment="parsed"
      segment-key="main"
    />
    <p v-else class="rat-mascot-mascot-only-bubble__text rat-mascot-mascot-only-bubble__text--message-body">
      <template v-for="(part, idx) in parsed.plainParts" :key="`plain-${idx}`">
        <strong v-if="part.bold">{{ part.text }}</strong>
        <template v-else>{{ part.text }}</template>
      </template>
    </p>
  </div>
</template>

<script>
import { parseAssistantReply, journalTableColumnKind, stripMarkdownInline } from '@/utils/assistantReplyFormat';
import AssistantReplyTextSegment from '@/components/AssistantReplyTextSegment.vue';

export default {
  name: 'AssistantReplyBody',
  components: { AssistantReplyTextSegment },
  props: {
    content: {
      type: String,
      default: '',
    },
    formatted: {
      type: Object,
      default: null,
    },
    pageMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    parsed() {
      if (this.formatted && typeof this.formatted === 'object') return this.formatted;
      return parseAssistantReply(this.content);
    },
  },
  methods: {
    formatTableCell(cell) {
      const v = stripMarkdownInline(cell);
      return v || '—';
    },
    tableBodyRows(seg) {
      const rows = Array.isArray(seg?.rows) ? seg.rows : [];
      return rows.filter((row) => {
        const first = stripMarkdownInline(row?.[0]);
        return first && !/^total/i.test(first);
      });
    },
    tableHeaderClass(header) {
      const kind = journalTableColumnKind(header);
      if (kind === 'debit') return 'rat-mascot-reply-table__th--debit';
      if (kind === 'credit') return 'rat-mascot-reply-table__th--credit';
      return '';
    },
    tableCellClass(header, cell) {
      const kind = journalTableColumnKind(header);
      const cleaned = stripMarkdownInline(cell);
      const hasValue = cleaned && cleaned !== '—';
      if (kind === 'debit' && hasValue) return 'rat-mascot-reply-table__td--debit';
      if (kind === 'credit' && hasValue) return 'rat-mascot-reply-table__td--credit';
      return '';
    },
  },
};
</script>
